// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__hKbla","notes":"Notes_notes__3xKnz","note":"Notes_note__30kWS","markdown":"Notes_markdown__1JaFi"};